import * as React from 'react';
interface IProps {
    title: string;
    children?: React.ReactElement<any>;
    wrapperStyles?: any;
    titleStyles?: any;
    isSeoTitle?: boolean;
}

export const CollapsibleDropDownTitle = ({
    title,
    wrapperStyles,
    children,
    isSeoTitle,
    titleStyles,
}: IProps) => {
    let styles = {
        ...titleStyles,
    };
    if (wrapperStyles?.text) {
        styles = {
            ...wrapperStyles.text,
            ...styles,
        };
    }
    const titleElement = isSeoTitle ? (
        <h2 style={styles} dangerouslySetInnerHTML={{ __html: title }} />
    ) : (
        <span style={styles} dangerouslySetInnerHTML={{ __html: title }} />
    );
    return (
        <div className="collapsibleSectionInfo" style={{ ...wrapperStyles }}>
            {children}
            {titleElement}
        </div>
    );
};
